import { Component, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { AzmoonMaharatDetail_Interface, Empty_AzmoonMaharatDetail_Interface } from 'src/app/Interface/AzmoonMaharatDetail_Interface';
import { AzmoonMaharatMain_Interface, Empty_AzmoonMaharatMain_Interface } from 'src/app/Interface/AzmoonMaharatMain_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { AzmoonMaharatService } from 'src/app/Service/AzmoonMaharat/AzmoonMaharat.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-AzmoonMaharatDetailList',
  templateUrl: './AzmoonMaharatDetailList.component.html',
  styleUrls: ['./AzmoonMaharatDetailList.component.scss']
})
export class AzmoonMaharatDetailListComponent implements OnInit {

  @Input() inner_AzmoonMaharatMain: AzmoonMaharatMain_Interface = Empty_AzmoonMaharatMain_Interface()
  @Output() outter_AzmoonMaharatMain = new EventEmitter<number>();

  Token: String = ""
  Filter_title: string = ""
  page: number = 0;
  Procssing: boolean = false
  BaseUrl = environment.BaseUrl+"File/AzmoonMaharat/"

  modalRef_Delete: any;
  modalRef_File: any;

  constructor(
    private AzmoonMaharat_Service: AzmoonMaharatService,
    private Alertify_Service: AlertifyService,
    private modalService: BsModalService
  ) { }


  DataList_AzmoonMaharat: Array<AzmoonMaharatDetail_Interface> = []
  Data_Seleted_Delete: AzmoonMaharatDetail_Interface = Empty_AzmoonMaharatDetail_Interface()

  ngOnInit() {
    this.Token = localStorage.getItem('Daro_User_Token');
    this.ReadData_AzmoonMaharat()
  }

  ReadData_AzmoonMaharat() {
    this.Procssing = true
    this.AzmoonMaharat_Service.GetDetail(this.inner_AzmoonMaharatMain.id,this.Token).subscribe(
      data => {
        this.DataList_AzmoonMaharat = data
        this.Procssing = false
      }, error => {
        localStorage.clear()
        location.reload();

      }
    )
  }

  Change_Filter_title() {
    this.page = 0
  }

  Delete(item: AzmoonMaharatDetail_Interface) {
    this.Procssing = true
    this.modalRef_Delete.hide()
    this.AzmoonMaharat_Service.DeleteDetail(item.id, this.Token).subscribe(
      data => {
        if (item.del == false)
          this.Alertify_Service.SuccessMessage("Deactivated successfully")
        else
          this.Alertify_Service.SuccessMessage("Activated successfully")
        this.ReadData_AzmoonMaharat()
      }, error => {
        localStorage.clear()
        location.reload();

      }
    )
  }

  openModal(template: TemplateRef<any>, Record) {
    this.Data_Seleted_Delete = Record
    this.modalRef_Delete = this.modalService.show(template);
  }

  openModalFile(template: TemplateRef<any>, Record) {
    this.Data_Seleted_Delete = Record
    this.modalRef_File = this.modalService.show(template);
  }

  //#region AzmoonMaharat Form

  Selected_AzmoonMaharat_Record: AzmoonMaharatMain_Interface
  Selected_AzmoonMaharat_Record_Switcher: string = 'List'
  Set_List_AzmoonMaharat_View() {
    this.ReadData_AzmoonMaharat()
    this.Selected_AzmoonMaharat_Record_Switcher = 'List'
  }

  Set_Form_AzmoonMaharat_View(item: AzmoonMaharatMain_Interface, Switcher: string) {
    this.Selected_AzmoonMaharat_Record = item
    this.Selected_AzmoonMaharat_Record_Switcher = Switcher
  }

  Set_Form_AzmoonMaharat_View_Add() {
    this.Selected_AzmoonMaharat_Record = Empty_AzmoonMaharatMain_Interface()
    this.Selected_AzmoonMaharat_Record_Switcher = 'Form'
  }

  //#endregion


  onBack() {
    this.outter_AzmoonMaharatMain.emit(-1);
  }


}
